import React, { useState, useEffect, useRef, Suspense } from "react";
import { useAuth } from '../context/AuthContextProvider';
import { createPreference, updatePreference, listPreference } from "src/utilities/AppSyncPlusAPIs";
import { v4 as uuidv4 } from 'uuid';


import {
  AppLayout,
  Box,
  Spinner,
} from "@amzn/awsui-components-react";

import "./homepage.scss";
import { useSelector } from "react-redux";
import { selectIsEffectiveAdmin, selectIsEffectiveSupportAdmin } from '../utilities/adminUtils';

import { useHistory } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import { getBrassIsLDAPOwnerOf, getOwnersByUser, getOwnersForAdminUser } from "src/utilities/CloseAPIs"
import { TEMPLATE_APP } from 'src/Ateam-BI/Templates/Constants';

import { configureGenericAppSync, configurePlusAppsync } from 'src/context/AuthContextUtility';
import { isMemberOf } from "src/checkPageAccess";

import { closePortalDefaultTabs, SIDE_NAV_TEAM_LABELS } from "./ClosePortal/constants"
import { getEditableFields } from "src/Ateam-BI/Templates/Utils/FormMetadata";
import { getLocalCache, setLocalCache } from "src/utilities/CacheHelper"
import { GET_OWNERS_CACHE_KEY, cacheVariables } from "src/AppConstants/CacheConstants"
import { FIXED_TABS } from "src/utilities/TabOrderUtils"

import SideNav from "./SideNav"
import { JournalEntryPage, ReconciliationPage, MarketplacePage, ATeamResourcesPage, ACResourcesPage, AccountingPolicyPage, MyTeamsPage } from "./ClosePortal/ResourcePages"
import BannerContainer from "src/Ateam-BI/Banners/BannerContainer";
import { BannerDisplayLocation } from "src/Ateam-BI/Banners/BannerTypes";
import PulseSurveyNotificationContainer from "src/Ateam-BI/PulseSurvey/PulseSurveyNotificationContainer";
import { PulseSurveyNotificationDisplayLocation } from "src/Ateam-BI/PulseSurvey/PulseSurveyNotificationTypes";
import { TeamPage } from "./ClosePortal/ResourcePages/TeamPage";
import AIDecisionTree from "./ClosePortal/ResourcePages/AIDecisionTree";
import ATEAMMCPExplorer from "./ClosePortal/ResourcePages/ATEAMMCPExplorer";

const AllProducts = (props) => {
  const history = useHistory();

  const { tabIdFromURL, pageId, teamId, id } = useParams()

  const userAuthenticationDetails = useAuth();
  const currentUser = useSelector((globalState) => globalState.auth.userId)
  const currentStage = useSelector((globalState) => globalState.auth.currentStage)
  const ln = useLocation()
  const search = useLocation().search
  const [activeTabId, setActiveTabId] = useState();
  const [activeHref, setActiveHref] = useState()
  const [visible, setVisible] = useState(false)

  const isPortalAdmin = useSelector(selectIsEffectiveAdmin)
  const isSupportAdmin = useSelector(selectIsEffectiveSupportAdmin)
  const [showLoadingIcon, setShowLoadingIcon] = useState(true)
  const [selectedSuggestion, setSelectedSuggestion] = useState("")

  const [selectedCPView, setSelectedCPView] = useState()
  const [cpOwnerOptions, setCpOwnerOptions] = useState([])
  const [viewAccess, setViewAccess] = useState()
  const [addOrEditAccess, setAddOrEditAccess] = useState()
  const searchParams = new URLSearchParams(search)
  const [NavOpen, setNavOpen] = useState(true)
  const [tabs, setTabs] = useState([])
  const [allTabs, setAllTabs] = useState([])
  const [allCustomTabs, setAllCustomTabs] = useState([])
  const [hiddenTabs, setHiddenTabs] = useState([])
  const [modalLoading, setModalLoading] = useState(false)
  const [fieldMetadata, setFieldMetadata] = useState({});
  const [regions, setRegions] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [customTabsLoaded, setCustomTabsLoaded] = useState(false)

  const [isAteamBI, setIsAteamBI] = useState(null)
  const [ownerTabConfigInfo, setOwnerTabConfigInfo] = useState([])
  const [currentTabPreferences, setCurrentTabPreferences] = useState([])
  const [tabConfigInfoLoaded, setTabConfigInfoLoaded] = useState(false)

  const [homeCPView, setHomeCPView] = useState()
  const generalResourcesCPView = cpOwnerOptions?.find(opt => opt?.label === '01.General Resources')

  const [orderedTabs, setOrderedTabs] = useState({
    fixedTabs: closePortalDefaultTabs.filter(tab => FIXED_TABS.includes(tab.id)),
    orderedReorderableTabs: [
      ...allTabs.filter(tab => !FIXED_TABS.includes(tab.id))
    ]
  });
  const [tabOrderLoaded, setTabOrderLoaded] = useState(false);

  const getCachedOwners = () => getLocalCache(GET_OWNERS_CACHE_KEY, cacheVariables[GET_OWNERS_CACHE_KEY]?.expiry);
  const setCachedOwners = (data) => setLocalCache(GET_OWNERS_CACHE_KEY, data);

  useEffect(() => {
    if (ln.pathname?.toLowerCase()?.startsWith('/appslibrary')) {
      setActiveTabId('AppsLibrary')
    } else {
      let tabId = tabIdFromURL ? tabIdFromURL?.replaceAll('%2F', '/') : 'HOME';
      setActiveTabId(tabId)
    }
  }, [ln, tabIdFromURL])

  useEffect(() => {
    if (ln.pathname?.toLowerCase()?.startsWith('/closeportal/home')) {
      if (!homeCPView && selectedCPView) {
        // Only set homeCPView to a team that's not a side nav resource team
        if (!SIDE_NAV_TEAM_LABELS.includes(selectedCPView?.label)) {
          setHomeCPView(selectedCPView)
        } else {
          // Fall back to first non-filtered team
          const firstValidTeam = cpOwnerOptions?.find(opt => !SIDE_NAV_TEAM_LABELS.includes(opt?.label));
          if (firstValidTeam) setHomeCPView(firstValidTeam)
        }
      }
      if (homeCPView && homeCPView?.value !== selectedCPView?.value) setSelectedCPView(homeCPView)
    }
  }, [ln.pathname, homeCPView, selectedCPView, cpOwnerOptions])

  useEffect(() => {
    if (teamId) {
      const teamOption = cpOwnerOptions?.find(opt => String(opt?.value) === String(teamId));
      if (teamOption && String(selectedCPView?.value) !== String(teamId)) {
        setSelectedCPView(teamOption);
      }
    }
  }, [teamId, cpOwnerOptions, selectedCPView?.value])

  // New
  useEffect(() => {
    if (selectedCPView) {
      updateAccess()
      setTabConfigInfoLoaded(false)
      setTabOrderLoaded(false)
      setCustomTabsLoaded(false)
      setTabs([])
      setAllTabs([])
      setAllCustomTabs([])
      setHiddenTabs([])
      setOwnerTabConfigInfo([])
      setTabConfigFromPreferences()


      if (!teamId && !pageId && activeTabId && activeTabId?.toLowerCase() !== 'appslibrary' && selectedCPView?.value) {
        if (searchParams.toString() && activeTabId?.toLowerCase() !== 'home') {
          history.push(`/ClosePortal/${activeTabId?.replaceAll('/', '%2F')}/Page/${selectedCPView?.value}?${searchParams.toString()}`)
        } else {
          history.push(`/ClosePortal/${activeTabId?.replaceAll('/', '%2F')}/Page/${selectedCPView?.value}`)
        }
      }
      if (!teamId && !pageId && activeTabId?.toLowerCase() === 'appslibrary' && selectedCPView?.value && ln.pathname?.toLowerCase()?.startsWith('/closeportal')) {
        history.replace(`/ClosePortal/AppsLibrary/Page/${selectedCPView?.value}${search ? search : ''}`)
      }
      // Also update when already on a /Page/:id route and team changes
      if (!teamId && id && tabIdFromURL && selectedCPView?.value && String(id) !== String(selectedCPView?.value)) {
        history.replace(`/ClosePortal/${tabIdFromURL}/Page/${selectedCPView?.value}${search ? search : ''}`)
      }
      if (pageId === 'HOME' && selectedCPView?.value) {
        history.replace(`/ClosePortal/HOME/Page/${selectedCPView?.value}${search ? search : ''}`)
      }
    }
  }, [selectedCPView, isPortalAdmin, isSupportAdmin])

  useEffect(() => {
    if (selectedCPView && allTabs?.length >= 1 && tabConfigInfoLoaded === true) {
      setTabOrderLoaded(true)
      setCustomTabsLoaded(true)
    } else {
      setTabOrderLoaded(false)
      setCustomTabsLoaded(false)
    }

  }, [selectedCPView, tabConfigInfoLoaded])




  useEffect(() => {
    if (customTabsLoaded === true) {
      
      if (!teamId && !pageId && !tabs?.map((tab)=>(tab?.id)).includes(tabIdFromURL?.replaceAll('%2F', '/')) && activeTabId?.toLowerCase() !== 'appslibrary') {
        setActiveTabId('HOME')
        history.push(`/ClosePortal/HOME/Page/${selectedCPView?.value}`)
      }
    }
  }, [customTabsLoaded, hiddenTabs])



  useEffect(() => {
    if (visible === true) {
      loadSearchDropDownValues()
    }
  }, [visible])

  useEffect(() => {
    checkAteamBIMembership()
  }, [isPortalAdmin, isSupportAdmin])

  useEffect(() => {
    if (isAteamBI != null) {
      loadData()
    }

  }, [isAteamBI])


  useEffect(() => {
    const orgs = fieldMetadata[TEMPLATE_APP.ORGANIZATION]?.values;
    setOrganizations(orgs);

    const regions = fieldMetadata[TEMPLATE_APP.REGION]?.values
    setRegions(regions)

  }, [fieldMetadata])


  const loadSearchDropDownValues = async () => {
    setModalLoading(true)
    let res = await getEditableFields()
    setFieldMetadata(res)
    setModalLoading(false)
  }


  const setTabConfigFromPreferences = async () => {
    listPreference(
      selectedCPView.value,
      'CLOSE_PORTAL',
      'CLOSE_PORTAL_TABS_CONFIG',
      function onSuccessResponse(response) {
        const preferences = response?.data?.listPreference?.items || [];

        const validPreferences = preferences.filter(pref => {
          if (pref.information) {
            const information = typeof pref.information === 'string'
              ? JSON.parse(pref.information)
              : pref.information;
            return information;
          }
          return false;
        });

        setCurrentTabPreferences(validPreferences)

        if (validPreferences?.length > 0) {
          const info = JSON.parse(validPreferences[0]?.information)
          if (info?.tabConfiguration?.closePortalTabs) {
            const tabConfigInfo = info?.tabConfiguration?.closePortalTabs
            setOwnerTabConfigInfo(tabConfigInfo)
            const visibleTabs = tabConfigInfo?.filter((tab) => tab?.visible)
            setTabs(visibleTabs)
            setAllTabs(tabConfigInfo)
            const customTabs = tabConfigInfo?.filter((tab) => tab?.isDefault === false)
            setAllCustomTabs(customTabs)
            const hiddenTabs = tabConfigInfo?.filter((tab) => tab?.visible === false)
            setHiddenTabs(hiddenTabs)
            setTabConfigInfoLoaded(true)
          }
        } else {
          setOwnerTabConfigInfo([])
          setTabs(closePortalDefaultTabs)
          setAllTabs(closePortalDefaultTabs)
          setAllCustomTabs([])
          setHiddenTabs([])
          setTabConfigInfoLoaded(true)
        }
      },
      function onFailureResponse(error) {
        configureGenericAppSync()
      }
    );

  }
  const handleOwnerSelection = (ownerSelectOptions) => {
    if (ownerSelectOptions.length > 0) {
      if (id || teamId) {
        const index = ownerSelectOptions?.findIndex((element) => {
          return element?.value == id || element?.value == teamId
        })
        if (index === -1) {
          const firstValidTeam = ownerSelectOptions.find(opt => !SIDE_NAV_TEAM_LABELS.includes(opt?.label)) || ownerSelectOptions[0];
          setHomeCPView(firstValidTeam)
          setSelectedCPView(firstValidTeam)
          setActiveTabId("HOME")
          history.push(`/ClosePortal/HOME/Page/${firstValidTeam?.value}`)
        } else {
          // If the landed team is a side nav resource team, set homeCPView to first valid team
          const landedTeam = ownerSelectOptions[index];
          if (SIDE_NAV_TEAM_LABELS.includes(landedTeam?.label)) {
            const firstValidTeam = ownerSelectOptions.find(opt => !SIDE_NAV_TEAM_LABELS.includes(opt?.label)) || ownerSelectOptions[0];
            setHomeCPView(firstValidTeam)
          } else {
            setHomeCPView(landedTeam)
          }
          setSelectedCPView(landedTeam)
        }
      } else {
        const firstValidTeam = ownerSelectOptions.find(opt => !SIDE_NAV_TEAM_LABELS.includes(opt?.label)) || ownerSelectOptions[0];
        setHomeCPView(firstValidTeam)
        setSelectedCPView(firstValidTeam)
      }
    }
  }

  const loadData = async () => {
    if (isPortalAdmin || isSupportAdmin) {
      const r = await getOwnersForAdminUser(function onSuccess(result) {
        const data = result.data.getOwnersForAdminUserRDS
        const owners = JSON.parse(data)
        const ownerSelectOptions = owners.map((owner) => {
          return { label: owner?.owner_name, value: String(owner?.owner_id), owner_identifier: owner?.owner_identifier, owner_type: owner?.owner_type }
        })
        setCpOwnerOptions(ownerSelectOptions)
        handleOwnerSelection(ownerSelectOptions)
        configureGenericAppSync()
        setShowLoadingIcon(false)
      }, function onFailure(response) {
        configureGenericAppSync()
        setShowLoadingIcon(false)
      })
    } else {
      if (cacheVariables[GET_OWNERS_CACHE_KEY].useCache) {
        const cachedData = getCachedOwners();
        if (cachedData) {
          setCpOwnerOptions(cachedData)
          handleOwnerSelection(cachedData)
          configureGenericAppSync()
          setShowLoadingIcon(false)
          return;
        }
      }

      const r = await getOwnersByUser(currentStage, function onSuccess(result) {
        const data = result.data.getOwnersByUser
        const owners = JSON.parse(data)
        const ownerSelectOptions = owners.map((owner) => {
          return { label: owner?.owner_name, value: owner?.owner_id, owner_identifier: owner?.owner_identifier, owner_type: owner?.owner_type }
        })
        if (cacheVariables[GET_OWNERS_CACHE_KEY].useCache) {
          setCachedOwners(ownerSelectOptions)
        }
        setCpOwnerOptions(ownerSelectOptions)
        handleOwnerSelection(ownerSelectOptions)
        configureGenericAppSync()
        setShowLoadingIcon(false)
      }, function onFailure(response) {
        configureGenericAppSync()
        setShowLoadingIcon(false)
      })
    }
  }

  const updateAccess = async () => {

    if (selectedCPView && selectedCPView?.owner_type === 'DEFAULT') {
      setViewAccess(true)
      if (isSupportAdmin || isPortalAdmin) {
        setAddOrEditAccess(true)
      } else {
        setAddOrEditAccess(false)
      }
    } else if (selectedCPView && selectedCPView?.owner_type === 'TEAM') {
      const isLDAPMemberOf = await isMemberOf(currentUser, selectedCPView?.owner_identifier, currentStage)
      let isLDAPOwnerOf;
      await configurePlusAppsync()
      const res = await getBrassIsLDAPOwnerOf(selectedCPView?.owner_identifier, currentStage, function onSuccess(result) {
        isLDAPOwnerOf = result.data.getBrassIsLDAPOwnerOf
        if (isLDAPOwnerOf || isLDAPMemberOf || isSupportAdmin || isPortalAdmin) {
          setViewAccess(true)
        } else {
          setViewAccess(false)
        }

        if (isLDAPOwnerOf || isSupportAdmin || isPortalAdmin) {
          setAddOrEditAccess(true)
        } else {
          setAddOrEditAccess(false)
        }
        configureGenericAppSync()
      }, function onFailure(response) {
        configureGenericAppSync()
      })
    } else if (selectedCPView && selectedCPView?.owner_type === 'USER' && selectedCPView?.owner_identifier === currentUser) {
      setViewAccess(true)
      setAddOrEditAccess(true)
    } else {
      setViewAccess(false)
      setAddOrEditAccess(false)
    }
  }

  const updateTab = (tabId, href) => {
    if (tabs?.map((tab) => (tab?.id)).includes(tabId)) {
      setActiveHref(href)
      setActiveTabId(tabId)
      return true;
    } else {
      return false;
    }

  }

  const addOrUpdateTabConfig = async (tabConfig) => {

    if (selectedCPView) {

      const newPreferenceId = uuidv4();
      const information = { "closePortalOwner": selectedCPView?.value, "tabConfiguration": { "closePortalTabs": tabConfig } }
      const label = `Tab configuration for Close Portal Page ${selectedCPView?.label}`
      if (ownerTabConfigInfo?.length <= 0) {
        createPreference(
          newPreferenceId,
          'CLOSE_PORTAL_TABS_CONFIG',
          label,
          selectedCPView?.value,
          'CLOSE_PORTAL',
          currentUser,
          information,
          null,
          (response) => {
            const newPreference = {
              preferenceId: newPreferenceId,
              label: label,
              associationId: selectedCPView?.value,
              associationIdType: 'CLOSE_PORTAL',
              preferenceType: 'CLOSE_PORTAL_TABS_CONFIG',
              createdBy: currentUser,
              lastUpdatedBy: currentUser,
              lastUpdatedTimestamp: Date.now().toString(),
              information: information
            };
            setCurrentTabPreferences([newPreference]);
            const info = newPreference?.information
            if (info?.tabConfiguration?.closePortalTabs) {
              const tabConfigInfo = info?.tabConfiguration?.closePortalTabs
              setOwnerTabConfigInfo(tabConfigInfo)
              const visibleTabs = tabConfigInfo?.filter((tab) => tab?.visible)
              setTabs(visibleTabs)
              setAllTabs(tabConfigInfo)
              const customTabs = tabConfigInfo?.filter((tab) => tab?.isDefault === false)
              setAllCustomTabs(customTabs)
              const hiddenTabs = tabConfigInfo?.filter((tab) => tab?.visible === false)
              setHiddenTabs(hiddenTabs)

            }
          },
          (error) => {
            console.error('Error creating preferences:', error);
            const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save preferences";
          }
        );
      } else {
        const currentPreferenceId = currentTabPreferences[0]?.preferenceId
        updatePreference(
          currentPreferenceId,
          label,
          currentUser,
          information,
          (response) => {
            const newPreference = {
              preferenceId: currentPreferenceId,
              label: label,
              associationId: props?.closePortalowner?.value,
              associationIdType: 'CLOSE_PORTAL',
              preferenceType: 'CLOSE_PORTAL_TABS_CONFIG',
              createdBy: currentUser,
              lastUpdatedBy: currentUser,
              lastUpdatedTimestamp: Date.now().toString(),
              information: information
            };
            setCurrentTabPreferences([newPreference]);
            const info = newPreference?.information
            if (info?.tabConfiguration?.closePortalTabs) {
              const tabConfigInfo = info?.tabConfiguration?.closePortalTabs
              setOwnerTabConfigInfo(tabConfigInfo)
              const visibleTabs = tabConfigInfo?.filter((tab) => tab?.visible)
              setTabs(visibleTabs)
              setAllTabs(tabConfigInfo)
              const customTabs = tabConfigInfo?.filter((tab) => tab?.isDefault === false)
              setAllCustomTabs(customTabs)
              const hiddenTabs = tabConfigInfo?.filter((tab) => tab?.visible === false)
              setHiddenTabs(hiddenTabs)
            }
          },
          (error) => {
            console.error('Error updating preferences:', error);
            const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save preferences";
          }
        )
      }

    }
  }

  const resetHref = () => {
    setActiveHref()
  }

  const checkAteamBIMembership = () => {
    setIsAteamBI(isPortalAdmin || isSupportAdmin);
  }

  useEffect(() => {
    setOrderedTabs({
      fixedTabs: closePortalDefaultTabs.filter(tab => FIXED_TABS.includes(tab.id)),
      orderedReorderableTabs: [
        ...allTabs?.filter(tab => !FIXED_TABS.includes(tab.id))
      ]
    })
  }, [allTabs])

  let Content = (
    showLoadingIcon ?
      <LargeSpinner/> :
      <MyTeamsPage
        selectedCPView={selectedCPView}
        setHomeCPView={setHomeCPView}
        setSelectedCPView={setSelectedCPView}
        cpOwnerOptions={cpOwnerOptions}
        viewAccess={viewAccess}
        addOrEditAccess={addOrEditAccess}
        tabs={tabs}
        allTabs={allTabs}
        allCustomTabs={allCustomTabs}
        hiddenTabs={hiddenTabs}
        regions={regions}
        organizations={organizations}
        isAteamBI={isAteamBI}
        tabOrderLoaded={tabOrderLoaded}
        orderedTabs={orderedTabs}
        updateTab={updateTab}
        resetHref={resetHref}
        setVisible={setVisible}
        visible={visible}
        refreshOwners={loadData}
        ownerTabConfigInfo={ownerTabConfigInfo}
        currentTabPreferences={currentTabPreferences}
        setOwnerTabConfigInfo={setOwnerTabConfigInfo}
        setTabs={setTabs}
        setAllTabs={setAllTabs}
        setAllCustomTabs={setAllCustomTabs}
        setHiddenTabs={setHiddenTabs}
        setCurrentTabPreferences={setCurrentTabPreferences}
      />
  );

  if (pageId === 'JournalEntry') {
    Content = !generalResourcesCPView ? 
      <LargeSpinner/> :
      <JournalEntryPage 
        selectedCPView={generalResourcesCPView} 
        viewAccess={viewAccess}
        addOrEditAccess={addOrEditAccess}
        resetHref={resetHref}
      />;
  }
  if (pageId === 'Reconciliation') {
    Content = !generalResourcesCPView ? 
      <LargeSpinner/> :
      <ReconciliationPage 
        selectedCPView={generalResourcesCPView} 
        viewAccess={viewAccess}
        addOrEditAccess={addOrEditAccess}
        resetHref={resetHref}
      />;
  }
  if (pageId === 'Marketplace') {
    Content = !generalResourcesCPView ? 
      <LargeSpinner/> :
      <MarketplacePage 
        selectedCPView={generalResourcesCPView} 
        addOrEditAccess={addOrEditAccess}
      />;
  }
  if (ln.pathname?.toLowerCase()?.startsWith('/appslibrary')) {
    Content = <MarketplacePage 
        selectedCPView={null} 
        addOrEditAccess={addOrEditAccess}
      />;
  }
  if (pageId === 'ACResources') {
    Content = !generalResourcesCPView ? 
      <LargeSpinner/> :
      <ACResourcesPage 
        selectedCPView={generalResourcesCPView} 
        viewAccess={viewAccess}
        addOrEditAccess={addOrEditAccess}
        resetHref={resetHref}
      />;
  }
  if (pageId === 'ATeamResources') {
    Content = !generalResourcesCPView ? 
      <LargeSpinner/> :
      <ATeamResourcesPage 
        selectedCPView={generalResourcesCPView} 
        viewAccess={viewAccess}
        addOrEditAccess={addOrEditAccess}
        resetHref={resetHref}
      />;
  }
  if (pageId === 'AIDecisionTree') {
    Content = !generalResourcesCPView ? 
      <LargeSpinner/> :
      <AIDecisionTree 
        selectedCPView={generalResourcesCPView} 
        viewAccess={viewAccess}
        addOrEditAccess={addOrEditAccess}
        resetHref={resetHref}
      />;
  }
  if (pageId === 'ATEAMMCPExplorer') {
    Content = !generalResourcesCPView ? 
      <LargeSpinner/> :
      <ATEAMMCPExplorer 
        selectedCPView={generalResourcesCPView} 
        viewAccess={viewAccess}
        addOrEditAccess={addOrEditAccess}
        resetHref={resetHref}
      />;
  }
  if (pageId === 'AccountingPolicy') {
    Content = !generalResourcesCPView ? 
      <LargeSpinner/> :
      <AccountingPolicyPage       
        selectedCPView={generalResourcesCPView} 
        viewAccess={viewAccess}
        addOrEditAccess={addOrEditAccess}
        resetHref={resetHref}
      />;
  }
  if (teamId) {
    const teamOption = cpOwnerOptions?.find(opt => String(opt?.value) === String(teamId));
    if (!teamOption && !showLoadingIcon) {
      Content = <PageNotFound />;
    } else if (teamOption) {
      Content = <TeamPage
          selectedCPView={teamOption}
          viewAccess={viewAccess}
          addOrEditAccess={addOrEditAccess}
          tabs={tabs}
          allTabs={allTabs}
          allCustomTabs={allCustomTabs}
          hiddenTabs={hiddenTabs}
          tabOrderLoaded={tabOrderLoaded}
          orderedTabs={orderedTabs}
          updateTab={updateTab}
          resetHref={resetHref}
          ownerTabConfigInfo={ownerTabConfigInfo}
          currentTabPreferences={currentTabPreferences}
          setOwnerTabConfigInfo={setOwnerTabConfigInfo}
          setTabs={setTabs}
          setAllTabs={setAllTabs}
          setAllCustomTabs={setAllCustomTabs}
          setHiddenTabs={setHiddenTabs}
          setCurrentTabPreferences={setCurrentTabPreferences}
      />
    }
  }

  return (
    <>
      <BannerContainer displayLocations={[BannerDisplayLocation.ClosePortal]} roundedCorners={true} parameters={{ closePortalOwnerId: selectedCPView?.value }} />
      <PulseSurveyNotificationContainer displayLocations={[PulseSurveyNotificationDisplayLocation.ClosePortal]} roundedCorners={true} parameters={{ closePortalOwnerId: selectedCPView?.value }} />
      <AppLayout
        disableContentPaddings={false}
        navigation={<SideNav activeHref={ln.pathname} selectedCPView={selectedCPView} homeCPView={homeCPView} setNavOpen={setNavOpen} cpOwnerOptions={cpOwnerOptions} />}
        navigationOpen={NavOpen}
        onNavigationChange={({ detail }) => setNavOpen(detail.open)}
        maxContentWidth={Number.MAX_VALUE}
        content={Content}
        contentType="default"
        headerSelector="#TopBar"
        toolsHide={true}
      />
    </>
  );
};

export default AllProducts;

const LargeSpinner = () => (
  <Box>
    <Spinner size="large" />
  </Box>
)

const PageNotFound = () => (
  <Box textAlign="center" padding={{ top: "xxxl" }}>
    <Box variant="h2" color="text-status-inactive">Page not found</Box>
    <Box variant="p" color="text-status-inactive" padding={{ top: "s" }}>
      The team you are looking for does not exist or you do not have access to it.
    </Box>
  </Box>
)
